/**
 * Detail／latest report：BE 回 nested `inspection`／`history`。
 * 扁平化給表單與 meta（不改 wire write：PATCH 仍送頂層 inspection_*）。
 */
export function normalizeRepairReportDetail(detail) {
  if (!detail || typeof detail !== 'object') {
    return detail;
  }

  const inspection = detail.inspection && typeof detail.inspection === 'object'
    ? detail.inspection
    : null;
  const history = detail.history && typeof detail.history === 'object'
    ? detail.history
    : null;

  const inspectionConclusion = detail.inspectionConclusion
    ?? inspection?.inspectionConclusion
    ?? null;
  const inspectionItems = Array.isArray(detail.inspectionItems)
    ? detail.inspectionItems
    : (Array.isArray(inspection?.inspectionItems) ? inspection.inspectionItems : []);
  const refuseReason = detail.refuseReason
    ?? history?.refuseReason
    ?? null;

  return {
    ...detail,
    inspectionConclusion,
    inspectionItems,
    refuseReason,
    history: history ?? detail.history ?? null,
  };
}
